import { useEffect, useState } from "react";
import { PRM_LIGHT_BLUE } from "_styles/colors";
import PRMLogo from "../../../assets/images/PRM-Logo-PNG/logo.png"
import { useSelector } from "react-redux";
import { selectAirportLogo, selectAirportLogoStatus } from "_redux/slices/analytics/reviews";
import iosimage from "_assets/images/PRM-Logo-PNG/ios-download.png";
import androidimage from "_assets/images/PRM-Logo-PNG/google-play.png";


const MobileButtons = () => {

    const iOSUrl = 'https://apps.apple.com/ie/app/prm-assist/id1574371912';
    const androidUrl = 'https://play.google.com/store/apps/details?id=com.prmassist';

    return (
        <div style={{ display: 'flex', marginBottom: 15, padding: 5 }}>
            <a href={iOSUrl}>
                <img
                    src={iosimage}
                    style={{ borderRadius: 10, height: 50 }}
                    href={iOSUrl}
                />
            </a>

            <a href={androidUrl}>
                <img
                    src={androidimage}
                    style={{ borderRadius: 10, height: 50, }}
                />
            </a>
        </div>
    )
}

const SurveyCompleted = () => {
    const finalPhase = "Thank you for completeing the survey and for providing us with useful feedback to help improve the passenger journeys"
    const finalBtn = "Survey Completed";
    const airportLogoStatus = useSelector(selectAirportLogoStatus);
    const airportLogo = useSelector(selectAirportLogo);

    const [iataLogo, setIataLogo] = useState("");

    useEffect(() => {
        if (airportLogoStatus === "succeeded") {
            setIataLogo(airportLogo)
        }
        if (airportLogoStatus === "failed") {
            setIataLogo(PRMLogo)
        }
    }, [airportLogoStatus])

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
            <div style={{ marginTop: "10px", textAlign: "center" }}>
                <p style={{ fontSize: 22, color: PRM_LIGHT_BLUE, opacity: 0.8, textAlign: "center" }}>
                    {finalBtn}
                </p>
                <p style={{ fontSize: 18, }}>{finalPhase}</p>
            </div>


            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexGrow: 1, justifyContent: "center" }} >
                <img src={iataLogo} alt="Belfast LOGO" style={{ width: "90%", maxWidth: "300px", marginBottom: "10px", maxHeight: "200px", objectFit: "contain" }} />
                <img src={PRMLogo} alt="PRM LOGO" style={{ width: "90%", maxWidth: "300px", marginBottom: "10px", maxHeight: "200px", objectFit: "contain" }} />
            </div>


            <h6 style={{ textAlign: "center", fontSize: "14px", width: "100%" }} >
                Powered by{" "} <strong style={{ color: PRM_LIGHT_BLUE }}>PRM ASSIST</strong>
            </h6>
            <MobileButtons />

        </div>
    );
}

export default SurveyCompleted